import {
  UserRepository,
  CompanyRepository,
  ApplicationRepository
} from "core/repository";
import { Base2Presenter } from "core/presenter";

export default class UserInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      title: "",
      loading: false,
      errorable: {
        visible: false,
        content: ""
      },
      deleteDialog: {
        visible: false,
        id: "",
        name: ""
      },
      form: {},
      currentUser: {},
      allowedCompanies: [],
      tokens: []
    };
  }

  // FIXME: How to I18n?
  static MineUserUuid = "minha-conta";

  setUserUuid(userUuid) {
    this.userUuid = userUuid;
  }

  async onStart() {
    this.enqueue({ loading: true });
    const currentUser = await this.mRuntime.get("currentUser");

    let userUuid = this.routeParams.userUuid;
    if (userUuid === UserInfoPresenter.MineUserUuid) {
      userUuid = currentUser.uuid;
    }
    this.setUserUuid(userUuid);

    await this.loadUser();
    await this.loadTokens();
    await this.getAllowedCompanies();

    this.enqueue({ currentUser });
    this.enqueue({ loading: false });
  }

  async loadUser() {
    const result = await UserRepository.getOnline(this.userUuid);

    if (result.success) {
      let form = result.data;
      form.companySlug = await this.getUserCompany(form.company_uuid);

      this.enqueue({
        title: form.name,
        form
      });
    } else {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos carregar este usuário! Tente novamente em alguns minutos."
      });
    }
  }

  async loadTokens() {
    const result = await ApplicationRepository.fetch({});

    if (result.success) {
      this.enqueue({ tokens: result.data });
    } else {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos carregar os tokens da API para este usuário! Tente novamente em alguns minutos."
      });
    }
  }

  async onViewUser() {
    this.navigateTo("app.registration.user", {});
  }

  async onEditUser(form) {
    this.navigateTo("app.registration.user.form", { userUuid: form.uuid });
  }

  async onRequestDelete(user) {
    const username = user.name || user.username || "Sem nome";
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir a empresa ${username}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDelete(user.uuid)
        }
      ]
    });
  }

  async doDelete(uuid) {
    this.enqueue({ loading: true });

    const result = await UserRepository.deleteUser(uuid);

    this.enqueue(vm => ({
      deleteDialog: {
        ...vm.deleteDialog,
        visible: false
      }
    }));

    if (result.success) {
      this.navigateTo("app.registration.user", {});
      this.sendNotification({
        type: "success",
        content: "O usuário foi excluído."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oooops...",
        content: "Não foi possível excluir o usuário."
      });
    }
    this.enqueue({ loading: false });
  }

  async getUserCompany(companyUuid) {
    const repositoryResult = await CompanyRepository.getOnline(companyUuid);
    let companySlug = "";

    if (repositoryResult.success) {
      companySlug = repositoryResult.data.slug;
    }

    return companySlug;
  }

  async getAllowedCompanies() {
    const allowedCompaniesUuids = this.viewModel.form.allowed_companies_uuids;
    const formCompanies = allowedCompaniesUuids || [];

    const allowedCompanies$ = formCompanies.map(async uuid => {
      const result = await CompanyRepository.getOnline(uuid);

      if (!result.success) {
        return {};
      }

      const company = result.data;

      return {
        uuid: company.uuid,
        slug: company.slug,
        cnpj: company.fiscal_informations.cnpj
      };
    });

    const allowedCompanies = await Promise.all(allowedCompanies$);
    this.enqueue({ allowedCompanies });
  }

  async onGenerateNewToken() {
    this.enqueue({ loading: true });

    const result = await ApplicationRepository.create();

    if (result.success) {
      await this.loadTokens();
    } else {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos criar um novo token da API para este usuário! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }

  onDeleteToken(token) {
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja o token ${token.api_key}?\nEssa ação não pode ser revertida e revogará as permissões de quaisquer aplicações utilizando este token.`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDeleteToken(token)
        }
      ]
    });
  }

  async doDeleteToken(token) {
    this.enqueue({ loading: true });

    const result = await ApplicationRepository.destroy(token.uuid);

    if (result.success) {
      await this.loadTokens();
    } else {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos deletar este token! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/user/info/user-info.presenter.js